import React, { useEffect } from 'react';
import { Box, Typography } from '@mui/material';
import { ICandidateSourcingPool } from './types';
import Api from './API';

interface CandidatePoolsTableActionComponentsProps {
  actionsState: {
    selectedItem: ICandidateSourcingPool | null;
    anchorEl: HTMLElement | null;
    isOpen: { [key: string]: boolean };
  };
  dispatch: any;
  refetchCandidatePools: () => void;
  onEmailAnalyticsClick: (pool: ICandidateSourcingPool) => void;
}

const CandidatePoolsTableActionComponents: React.FC<CandidatePoolsTableActionComponentsProps> = ({
  actionsState,
  dispatch,
  refetchCandidatePools,
  onEmailAnalyticsClick
}) => {
  const handleDeletePool = async () => {
    if (actionsState.selectedItem && confirm('Are you sure you want to delete this pool?')) {
      try {
        await Api.deleteCandidatePool(actionsState.selectedItem.id);
        refetchCandidatePools();
        dispatch({ type: 'CLOSE_ACTION_ITEM', payload: 'delete' });
      } catch (error) {
        console.error('Error deleting pool:', error);
      }
    } else {
      dispatch({ type: 'CLOSE_ACTION_ITEM', payload: 'delete' });
    }
  };

  const handleBulkEmail = () => {
    if (actionsState.selectedItem) {
      dispatch({ type: 'SELECT_ALL_ITEMS', payload: [actionsState.selectedItem.id] });
      dispatch({ type: 'SET_ACTION_MODAL_OPEN', payload: { name: 'email', isOpen: true } });
    }
    dispatch({ type: 'CLOSE_ACTION_ITEM', payload: 'bulk_email' });
  };

  const handleEmailAnalytics = () => {
    if (actionsState.selectedItem) {
      onEmailAnalyticsClick(actionsState.selectedItem);
    }
    dispatch({ type: 'CLOSE_ACTION_ITEM', payload: 'candidatePool' });
    dispatch({ type: 'CLOSE_ACTION_ITEM', payload: 'emailAnalytics' });
  };

  useEffect(() => {
    if (actionsState.isOpen?.delete) {
      handleDeletePool();
    }
    if (actionsState.isOpen?.bulk_email) {
      handleBulkEmail();
    }
    if (actionsState.isOpen?.emailAnalytics) {
      handleEmailAnalytics();
    }
  }, [
    actionsState.isOpen?.delete,
    actionsState.isOpen?.bulk_email,
    actionsState.isOpen?.emailAnalytics,
    actionsState.selectedItem
  ]);

  return (
    <Box sx={{ marginTop: '20px' }}>
      {actionsState.selectedItem && (
        <Typography variant="body2" color="text.secondary">
          Selected Pool: {actionsState.selectedItem.title}
        </Typography>
      )}
    </Box>
  );
};

export default CandidatePoolsTableActionComponents;
